import React from 'react';
import { connect } from 'react-redux';
import { Switch, Route, withRouter, Redirect, Link } from 'react-router-dom';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { Acl } from 'modules/common/components/Acl';
import { getJson } from 'session';
import SeniorCitizenSettingsTabContainer from './senior-citizen/SeniorCitizenSettingsTabContainer';
import SingleParentSettingsTabContainer from './single-parent/SingleParentSettingsTabContainer';
import StudentSettingsTabContainer from './student/StudentSettingsTabContainer';
import PwdSettingsTabContainer from './pwd/PwdSettingsTabContainer';

function SocialAmeliorationSettings({ match, pathName }) {
  const permissions = getJson('permissions');

  return (
    <React.Fragment>
      <div className="card-content-listing">
        <div className="container-fluid">
          <div className="row border-bottom-row">
            <ul className="nav nav-tabs sub-tab-borongan">
              {Acl(permissions, ['VIEW SENIOR CITIZEN SETTINGS']) && (

                <li className="nav-item">
                  <Link
                    to="/social-ameliorations/settings"
                    className={`nav-link sub-tab py-3 px-5 ${pathName.indexOf('social-ameliorations/settings/senior-citizen') > -1
                      ? 'selected'
                      : ''
                      }`}
                  >
                    Senior Citizen
                  </Link>
                </li>
              )}
              {Acl(permissions, ['VIEW PWD SETTINGS']) && (
                <li>
                  <Link
                    to="/social-ameliorations/settings/pwd"
                    className={`nav-link sub-tab py-3 px-5 ${pathName.indexOf('social-ameliorations/settings/pwd') > -1
                      ? 'selected'
                      : ''
                      }`}
                  >
                    PWD
                  </Link>
                </li>
              )}
              {Acl(permissions, ['VIEW STUDENT SETTINGS']) && (
                <li>
                  <Link
                    to="/social-ameliorations/settings/student"
                    className={`nav-link sub-tab py-3 px-5 ${pathName.indexOf('social-ameliorations/settings/student') > -1
                      ? 'selected'
                      : ''
                      }`}
                  >
                    Student
                  </Link>
                </li>
              )}
              {Acl(permissions, ['VIEW SINGLE PARENT SETTINGS']) && (
                <li>
                  <Link
                    to="/social-ameliorations/settings/single-parent"
                    className={`nav-link sub-tab py-3 px-5 ${pathName.indexOf('social-ameliorations/settings/single-parent') > -1
                      ? 'selected'
                      : ''
                      }`}
                  >
                    Solo Parent
                  </Link>
                </li>
              )}
            </ul>
          </div>
        </div>
        <Switch>
          <Route
            exact
            path={`${match.path}`}
            render={() => <Redirect to={`${match.path}/senior-citizen`} />}
          />

          {Acl(permissions, ['VIEW SENIOR CITIZEN SETTINGS']) && (
            <Route
              path={`${match.path}/senior-citizen`}
              component={SeniorCitizenSettingsTabContainer}
            />
          )}

          {Acl(permissions, ['VIEW PWD SETTINGS']) && (
            <Route
              path={`${match.path}/pwd`}
              component={PwdSettingsTabContainer}
            />
          )}

          {Acl(permissions, ['VIEW STUDENT SETTINGS']) && (
            <Route
              path={`${match.path}/student`}
              component={StudentSettingsTabContainer}
            />
          )}

          {Acl(permissions, ['VIEW SINGLE PARENT SETTINGS']) && (
            <Route
              path={`${match.path}/single-parent`}
              component={SingleParentSettingsTabContainer}
            />
          )}
        </Switch>
      </div>
    </React.Fragment>
  );
}

SocialAmeliorationSettings.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
  pathName: PropTypes.string.isRequired,
};

const mapStateToProps = ({ api }, { match, location }) => ({
  mainModule: _.get(match, 'params.mainModule'),
  pathName: _.get(location, 'pathname'),
  profile: _.get(api, 'AUTH/user_profile.item') || {},
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps)]);

export default enhance(SocialAmeliorationSettings);
